module.exports = __webpack_public_path__ + "img/novos-talentos-card-o-aprendiz.6e59442d.png";